import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";

export const StatusBadge = styled.div<{
  border: string;
  bg?: string;
  $color?: string;
  padding?: string;
  $filterTag?: boolean;
  $filterTypography?: boolean;
  $normalizeIconStroke?: boolean;
}>`
  display: inline-flex;
  width: fit-content;
  height: ${({ $filterTag }) => ($filterTag ? "32px" : "auto")};
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-start;
  gap: ${vars.spacing.xxs};
  overflow: hidden;
  padding: ${({ padding, $filterTag }) =>
    padding ||
    ($filterTag ? `0 ${vars.spacing.sm}` : `${vars.spacing.xs} 12px`)};
  border: ${({ border }) =>
    border === "none" ? "0" : `${vars.borderWidth.thin} solid ${border}`};
  border-radius: ${vars.radius.full};
  background-color: ${({ bg, border }) =>
    bg ||
    (border === "none"
      ? vars.color.background.transparent
      : `color-mix(in srgb, ${border} 18%, ${vars.color.background.surface})`)};
  color: ${({ border, $color }) =>
    $color ||
    (border === "none"
      ? vars.color.text.primary
      : `color-mix(in srgb, ${border} 70%, ${vars.color.text.primary})`)};
  font-family: ${vars.typography.family.sans};
  font-size: var(--inzeloop-ds-font-size-14-4px);
  font-weight: ${vars.typography.weight.semibold};
  line-height: var(--inzeloop-ds-line-height-tight);
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $filterTag }) =>
    $filterTag &&
    `
      svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }
    `}

  ${({ $normalizeIconStroke }) =>
    $normalizeIconStroke &&
    `
      svg [stroke] {
        stroke-width: 0.666667;
      }
    `}
`;

export const StatusBadgeIcon = styled.div<{ bg: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${vars.spacing.xs};
  border-radius: ${vars.radius.full};
  background-color: ${({ bg }) => bg};
  color: ${vars.color.text.primary};
  font-family: ${vars.typography.family.sans};
  font-size: ${vars.typography.size.sm};
  font-weight: ${vars.typography.weight.semibold};
  line-height: ${vars.typography.lineHeight.xs};
`;
